import React, { ReactNode } from 'react';

const stack = [] as string[];
const fmt = text => [text, 'Metro Retro'].filter(x => !!x).join(' | ');

export class SetTitle extends React.Component<{ to: string, children?: ReactNode }> {

    private index: number;

    public render = () => this.props.children || false;

    public componentDidMount() {
        this.index = stack.length;
        stack.push(this.props.to);
        window.document.title = fmt(this.props.to);
    }

    public componentWillUnmount() {
        this.index = null;
        stack.pop();
        window.document.title = fmt(stack[stack.length - 1]);
    }

    public componentDidUpdate() {
        if (!!this.index || this.index === 0) {
            stack[this.index] = fmt(this.props.to);
            if (stack.length - 1 === this.index) {
                window.document.title = fmt(this.props.to);
            }
        }
    }
}
